<template>
    <header class="fixed top-0 left-0 right-0 h-20 flex items-center justify-between bg-black text-white z-40 px-6 print:hidden">

        <a class="text-xl font-semibold" href="/">{{ site.name }}</a>

        <div class="hidden md:flex items-center justify-between gap-6">
            <template v-if="site.navigation?.header?.length" v-for="page in site.navigation?.header">
                <a
                    class="font-semibold hover:text-[var(--primary-400)]"
                    :href="page.url"
                    v-html="(page.navigation_label || page.title)"
                ></a>
            </template>
        </div>

        <div class="md:hidden" @click="mobileMenuOpen = !mobileMenuOpen">
            <i class="fa-fw fa-light fa-sharp fa-bars text-2xl"></i>
        </div>

        <div class="md:hidden fixed inset-0 bg-black text-white z-50 overflow-hidden flex flex-col h-full" v-if="mobileMenuOpen">
            <div class="flex items-center justify-between border-b border-[var(--primary-400)] p-4">
                <div class="text-xl font-semibold">
                    {{ site.name }}
                </div>
                <div @click="mobileMenuOpen = !mobileMenuOpen">
                    <i class="fa-fw fa-light fa-sharp fa-times text-3xl"></i>
                </div>
            </div>
            <div class="flex-1 overflow-y-auto">
                <template v-if="site.navigation?.header?.length" v-for="page in site.navigation?.header">
                    <a class="block p-3 my-3 font-semibold hover:text-[var(--primary-400)]"
                        :href="page.url"
                       v-html="(page.navigation_label || page.title)"
                    ></a>
                </template>
            </div>
        </div>

    </header>
</template>

<script>
export default {
    name: 'SiteHeader',
    data() {
        return {
            mobileMenuOpen: false,
            site: window.app?.site || {},
        };
    },
};
</script>
